import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import { RalewayFont } from 'constants/fonts';
import { black, red } from 'constants/colors';

export const AffiliationModalWrapper = styled(Modal)`
  .loading_wrapper {
    height: 90%;
  }

  .modal {
    padding: 2rem 0
  }

  .affiliation_card {
    border-radius: 1.5rem;
    width: 80rem;
    ma-width: 80vw;
    height: calc(94vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
    font-family: ${RalewayFont.regularFamily}

    .affiliation_info {
      padding: 2rem;

      .icon {
        width: 5rem;
        height: 5rem;
        border-radius: 2.5rem;
        margin: 0;
        display: inline-block;
        background-size: contain;
        background-position: 50%;
        background-repeat: no-repeat;
        border: 2px solid black;
        vertical-align: middle;
      }

      .info {
        display: inline-block;
        margin: 1rem;
        vertical-align: middle;
        width: calc(100% - 10rem);
        word-break: break-all;

        p {
          margin-bottom: 1rem;
          font-size: 1.3rem;
          font-family: ${RalewayFont.boldFamily}
        }

        a {
          color: #2680EB;
          font-size: 1.3rem;
          display: block;
          font-family: ${RalewayFont.regularFamily}
        }
      }

      .btn_belong {
        border-radius: 20px;
        font-size: 1.2rem;
        border: 0px;
        color: #fff;
        background-color: #1976d2;
        padding: 0.8rem;
        float: none;
        word-break: break-word;
        margin: 1rem 0;
      }
      .btn_dont_belong {
        border-radius: 20px;
        font-size: 1.2rem;
        border: 0px;
        color: #fff;
        background-color: ${red};
        padding: 0.8rem;
        float: none;
        margin: 1rem 0;
        word-break: break-word;
      }
    }

    .sponsor {
      background-color: #f2f2f2;
      font-size: 1.4rem;
      font-family: ${RalewayFont.regularFamily};
      padding: 1rem;
    }

    .people {
      margin: 2rem 2rem 0rem;

      .face_bubble_text {
        color: ${black};
        white-space: normal;
      }

      .users_wrapper {
        display: inline-block;
        white-space: nowrap;
        overflow-y: hidden;
        overflow-x: scroll;

        .users {
          padding: 1rem;
          font-family: ${RalewayFont.boldFamily}
          font-size: 1rem;
          display: inline-block;
          margin: 1.5rem;
          width: 8rem;
          height: 10rem;

          .user_content {
            margin-top: 1.5rem;

            .name {
              width: 8rem;

            }
          }
        }
      }
    }

    .tables {
      margin: 0rem 2rem 2rem;

      .tables_wrapper {
        display: inline-block;
        width: auto;
        padding: 1rem;
        white-space: nowrap;
        overflow-y: hidden;
        overflow-x: scroll;

        .tables {
          padding: 1rem;
          display: inline-block;
          margin: 1.5rem;

          .name {
            text-align: center;
            font-family: ${RalewayFont.boldFamily}
            font-size: 1.3rem;
          }
        }
      }
    }
  }



  button {
    float: right;

  }
`;



// WEBPACK FOOTER //
// ./src/components/AffiliationCard/components/styles.js